import { createFileRoute, redirect } from '@tanstack/react-router';
import { UserRoles } from '~entities/users';

import { RegistrationConfig } from '~pages/settings/new-dynamic-config';
import { checkMinRoleValue } from '~shared/utils/role-guard';

const PendingComponent = () => {
  return (
    <div className='flex h-screen items-center justify-center'>Loading....</div>
  );
};

export const Route = createFileRoute('/_auth/settings')({
  beforeLoad: async () => {
    const hasAccess = await checkMinRoleValue(UserRoles.SUPER_ADMIN);
    if (!hasAccess) {
      return redirect({
        to: '/dashboard',
      });
    }
  },
  pendingComponent: PendingComponent,
  component: RouteComponent,
});

function RouteComponent() {
  return <RegistrationConfig />;
}
